import { useMutation, useQueryClient } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';

const useUpdateClientUserMutation = (options = {}) => {

  const firebase = useFirebase();
  const queryClient = useQueryClient();
  const { onSettled, ...rest } = options;

  return useMutation({
    mutationFn: async (variables) => {
      const { clientId, userId, data } = variables;
      const agent = await firebase.getAgent();
      const response = await agent.patch(`/clients/${encodeURIComponent(clientId)}/users/${encodeURIComponent(userId)}`).send(data);
      return response;
    },
    onSettled: (data, error, variables, context) => {
      const { clientId, userId } = variables;
      if (onSettled) {
        onSettled(data, error, variables, context);
      }
      if (!error && clientId && userId) {
        return Promise.all([
          queryClient.invalidateQueries([`/clients/${clientId}/users`]),
          queryClient.invalidateQueries([`/clients/${clientId}/users/${userId}`]),
        ]);
      }
    },
    ...rest,
  });
};

export default useUpdateClientUserMutation;
